// extracted by mini-css-extract-plugin
export default {"btn-change":"ModalChangeStore_btn-change__nkjIG"};